import axios from 'axios'

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('admin-token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token and redirect to login if unauthorized
      const isAdminRoute = window.location.pathname.startsWith('/admin')
      if (isAdminRoute && window.location.pathname !== '/admin/login') {
        localStorage.removeItem('admin-token')
        window.location.href = '/admin/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api

// Helper functions
export const getTests = (params) => api.get('/tests', { params })
export const getTest = (slug) => api.get(`/tests/${slug}`)
export const getCategories = () => api.get('/tests/categories')

export const createOrder = (data) => api.post('/orders', data)
export const getOrderConfirmation = (orderNumber) => api.get(`/orders/confirm/${orderNumber}`)

export const createPaymentIntent = (orderId) => api.post('/payment/create-intent', { orderId })
export const confirmPayment = (paymentIntentId, orderId) => api.post('/payment/confirm', { paymentIntentId, orderId })
export const getPaymentConfig = () => api.get('/payment/config')

export const submitContact = (data) => api.post('/contact', data)

// Admin endpoints
export const getDashboard = () => api.get('/admin/dashboard')
export const getPendingOrders = () => api.get('/admin/orders/pending')
export const placeHealthLabsOrder = (id, data) => api.put(`/admin/orders/${id}/place`, data)
export const getOrders = (params) => api.get('/orders', { params })
export const getOrder = (id) => api.get(`/orders/${id}`)
export const updateOrder = (id, data) => api.put(`/orders/${id}`, data)
export const seedTests = () => api.post('/admin/tests/seed')
export const setupAdmin = () => api.post('/admin/setup')
export const getContacts = (params) => api.get('/admin/contacts', { params })
export const updateContact = (id, data) => api.put(`/admin/contacts/${id}`, data)
